import Bundle from "@framework/Bundle";

export const routes = require.context(
	"./",
	true,
	/.*\/@module($|\/routes\.(js))/
);

/* webpack-strip-block:removed */
/* REMOVE-FOR-SERVER-START */
/* REMOVE-FOR-CLIENT-SSR-START */
export const controllers = [{value: () => import(/* webpackPreload: true */ "./@module/controller.js"), path: "./@module/controller.js"}];
export const models = [];
/* REMOVE-FOR-CLIENT-SSR-END */
export const libs = [];
export const styles = [{value: () => import(/* webpackPreload: true */ "./@styles/Home.styles.js"), path: "./@styles/Home.styles.js"}];
export const constants = [];
export const loadable = require.context("./", true, /\.(loadable)\.(js)$/);
export const stores = [{value: () => import(/* webpackPreload: true */ "./@stores/CompleteProfile.store.js"), path: "./@stores/CompleteProfile.store.js"}, {value: () => import(/* webpackPreload: true */ "./@stores/Home.store.js"), path: "./@stores/Home.store.js"}, {value: () => import(/* webpackPreload: true */ "./@stores/MissingInformation.store.js"), path: "./@stores/MissingInformation.store.js"}, {value: () => import(/* webpackPreload: true */ "./@stores/Today.store.js"), path: "./@stores/Today.store.js"}];
export const extensions = [];
export const background = require.context("./", true, /\.(background)\.(js)$/);
/* webpack-strip-block:removed */
/* webpack-strip-block:removed */
/* REMOVE-FOR-SERVER-END */
